<template>
  <section class="section-book-additional-hours p-4">
    <!-- Navigation -->
    <div class="row mb-3">
      <div class="col-12 col-md-8 offset-md-2">
        <router-link to="/my-reservations" class="text-primary-link">
          {{ $t('message.menu.my_reservations') }}
        </router-link>
        <i class="fal fa-angle-right"></i>
        <router-link class="text-primary-link" :to="`/reservation/${order.id}`">
          {{ $t('message.my_reservations.reservation_detail') }}
        </router-link>
        <i class="fal fa-angle-right"></i>
        {{ $t('message.my_reservations.book_additional_ironing_service') }}
      </div>
    </div>

    <div class="row pt-4">
      <div class="col-12 col-lg-6 offset-lg-3">
        <!-- Form -->
        <section>
          <div class="row no-gutters d-flex align-items-center justify-content-center">
            <div class="col-8">
              <label class="mb-0">{{ $t('message.booking.booking_step.cloth_qty') }}:</label>
            </div>
            <div class="col-4">
              <b-input-group>
                <b-input-group-prepend>
                  <b-button variant="info" @click="decreaseAmount()">
                    <i class="fas fa-minus"></i>
                  </b-button>
                </b-input-group-prepend>
                <b-form-input v-model="purchaseQty" class="text-center"></b-form-input>
                <b-input-group-append>
                  <b-button variant="info" @click="increaseAmount()">
                    <i class="fas fa-plus"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </section>
        <!-- Cost -->
        <section v-if="subtotal">
          <hr/>
          <div class="row text-remark">
            <div class="col-6 p-0">
              {{ $t('message.my_reservations.summary_total.subtotal') }}
            </div>
            <div class="col-6 p-0 text-right">
              {{ subtotal | currency }}
            </div>
          </div>
          <div class="row text-remark mt-1">
            <div class="col-6 p-0">
              {{ $t('message.my_reservations.summary_total.service_vat') }}
            </div>
            <div class="col-6 p-0 text-right">
              {{ (subtotal * globalState.serviceVat) | currency }}
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-6 p-0">
              <label>{{
                $t('message.my_reservations.summary_total.total')
                }}</label>
            </div>
            <div class="col-6 p-0 text-right">
              <label>{{ (subtotal + subtotal * globalState.serviceVat) | currency }}</label>
            </div>
          </div>
        </section>
        <!-- Payment -->
        <section>
          <hr/>
          <payment-methods ref="paymentMethods"
                           @onSelectedPaymentMethod="updatePaymentMethod"
                           @onSelectedCreditCard="applyUserCreditCard"
                           @onRequestedSavingTempData="saveTempData"
                           @onSelectedFileUpload="setFileUpload"
                           @onSuccessQrPayment="displaySuccessDialog"></payment-methods>
        </section>

        <div class="pt-2">
          <button class="btn btn-info btn-block"
                  :disabled="isLoading"
                  v-if="paymentMethod !== 'promptpay'"
                  @click="submitData()">
            {{ isLoading ? $t('message.button.loading') : $t('message.button.ok') }}
          </button>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { orderMixin } from '../../mixins/orderMixin'
  import PaymentMethods from './PaymentMethods'
  import axios from 'axios'

  export default {
    mixins: [orderMixin],
    components: {
      PaymentMethods
    },
    data () {
      return {
        parentServiceId: 2,
        purchaseQty: null,
        unitCost: null,
        minQty: null,
        maxQty: null,
        subtotal: null,
        serviceVat: null,
        totalPrice: null,
        paymentMethod: null,
        omiseCustomerId: null,
        fileUpload: null,
        isLoading: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        order: 'orderDetail/getOrderDetail',
        user: 'auth/getUser'
      }),
      ...mapState('orderDetail', ['tmpPurchaseServiceData'])
    },
    watch: {
      purchaseQty () {
        if (this.purchaseQty) {
          if (this.purchaseQty <= 1) {
            this.purchaseQty = 2
          } else if (this.purchaseQty > this.maxQty) {
            this.purchaseQty = this.maxQty
          }
          this.reCalculateCost()
        }
      },
      totalPrice () {
        this.updateQrPayment()
      },
      paymentMethod () {
        this.updateQrPayment()
      }
    },
    methods: {
      increaseAmount () {
        if (this.purchaseQty < this.maxQty) {
          this.purchaseQty += 1
          this.reCalculateCost()
        }
      },
      decreaseAmount () {
        if (this.purchaseQty > this.minQty) {
          this.purchaseQty -= 1
          this.reCalculateCost()
        }
      },
      reCalculateCost () {
        this.subtotal = this.unitCost * this.purchaseQty
        this.serviceVat = Math.round((this.subtotal * this.globalState.serviceVat) * 100) / 100
        this.totalPrice = Number(this.subtotal) + Number(this.serviceVat)
      },
      initServiceData () {
        const services = this.globalState.services
        if (services) {
          for (let key in services) {
            const service = services[key]
            if (service.id === this.parentServiceId) {
              this.unitCost = Number(service.unit_cost)
              this.minQty = Number(service.min_qty)
              this.maxQty = Number(service.max_qty)
              this.purchaseQty = this.minQty
              break
            }
          }
        }
      },
      getPurchaseServiceData () {
        const submitData = {
          user_id: this.user.id,
          order_id: this.order.id,
          service_id: this.parentServiceId,
          purchase_qty: this.purchaseQty,
          total_price: this.subtotal,
          service_vat: this.serviceVat,
          product_type: 'service',
          payment_method: this.paymentMethod,
          omise_customer_id: this.omiseCustomerId,
          language: this.$i18n.locale
        }
        return submitData
      },
      async updateQrPayment () {
        if (this.paymentMethod === 'promptpay') {
          const url = `/purchases/service`
          const submitData = this.getPurchaseServiceData()
          let {data} = await axios.post(url, submitData)
          if (data.error) {
            this.$swal({text: data.message, type: 'error'})
          } else {
            // Create qr code
            if (data.purchase) {
              const qrPaymentData = {
                paymentFor: 'normal',
                purchaseId: data.purchase.id,
                amount: this.totalPrice
              }
              this.$refs.paymentMethods.updateQrPaymentData(qrPaymentData)
            }
          }
        }
      },
      updatePaymentMethod (paymentMethod) {
        this.paymentMethod = paymentMethod
      },
      applyUserCreditCard (data) {
        this.paymentMethod = data.payment_method
        this.omiseCustomerId = data.omise_customer_id
      },
      saveTempData () {
        const servicePurchaseData = this.getPurchaseServiceData()
        this.$store.commit('orderDetail/SET_TMP_PURCHASE_SERVICE_DATA', servicePurchaseData)
      },
      setFileUpload (file) {
        this.fileUpload = file
      },
      displaySuccessDialog (alertMessage = this.$i18n.t('message.payment_method.payment_success')) {
        if (this.tmpPurchaseServiceData) {
          this.$store.commit('orderDetail/SET_TMP_PURCHASE_SERVICE_DATA', null)
        }
        this.$swal({
          text: alertMessage,
          type: 'success',
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonColor: '#17a2b8',
          confirmButtonText: this.$i18n.t('message.button.close')
        }).then((result) => {
          if (result) {
            this.$router.push(`/reservation/${this.order.id}`)
          }
        })
      },
      submitData () {
        if (this.paymentMethod) {
          switch (this.paymentMethod) {
            case 'credit_card':
              this.addServicePurchase()
              break
            case 'bank_transfer':
              // Payment with bank transfer
              if (!this.fileUpload) {
                const alertMessage = this.$i18n.t('message.alert.no_file_upload')
                this.$swal({text: alertMessage, type: 'error'})
              } else {
                this.addServicePurchase()
              }
              break
          }
        } else {
          this.$swal({text: this.$i18n.t('message.alert.select_payment_method')})
        }
      },
      async addServicePurchase () {
        this.isLoading = true
        const submitData = this.getPurchaseServiceData()
        const url = '/purchases/service'
        const {data} = await axios.post(url, submitData)
        this.isLoading = false
        if (!data.error) {
          if (this.paymentMethod === 'credit_card') {
            this.displaySuccessDialog()
          } else if (this.paymentMethod === 'bank_transfer') {
            if (data.purchase) {
              const purchaseId = data.purchase.id
              let formData = new FormData()
              formData.append('purchase_id', purchaseId)
              formData.append('files', this.fileUpload)
              const res = await axios.post('/bank-transfers', formData)
              if (res.data && !res.data.error) {
                const alertMessage = this.$i18n.t('message.payment_method.bank_transfer_success')
                this.displaySuccessDialog(alertMessage)
              }
            }
          }
        } else {
          this.$swal({text: data.message, type: 'error'})
        }
      }
    },
    mounted () {
      this.initServiceData()
      this.reCalculateCost()
      // Check temp data
      if (this.tmpPurchaseServiceData) {
        setTimeout(() => {
          this.paymentMethod = this.tmpPurchaseServiceData.payment_method
          this.$refs.paymentMethods.setPaymentMethod(this.paymentMethod)
        }, 500)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/PurchaseService.vue